import EducatorsLanding from "@/features/educators/components/educators-landing";

export default function Educators() {
  return <EducatorsLanding />;
}
